/* 台账通回到顶部：与工具站/CMS 同款（悬浮按钮 + 滚动进度环），样式复用 tools.css 的 .tool-float-* */
(function () {
  'use strict';
  var btns = document.querySelectorAll('[data-tool-ui="backTop"]');
  if (!btns.length) return;
  var CIRC = 138.2; // 2π×22，进度环周长（与 tools.css stroke-dasharray 一致）
  var threshold = 300;
  var lastPct = -1;
  function sync() {
    var top = window.pageYOffset || document.documentElement.scrollTop || 0;
    var show = top > threshold;
    var max = document.documentElement.scrollHeight - window.innerHeight;
    var pct = max > 0 ? Math.min(Math.max(top / max, 0), 1) : 0;
    var pctChanged = pct !== lastPct;
    if (pctChanged) lastPct = pct;
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      btn.className = btn.className.replace(/\s*is-show/, '') + (show ? ' is-show' : '');
      if (pctChanged) {
        var ring = btn.querySelector('.tool-float-ring-pg');
        if (ring) ring.style.strokeDashoffset = (CIRC * (1 - pct)).toFixed(1);
      }
    }
  }
  window.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-tool-ui="backTop"]') : null;
    if (!btn) return;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  window.addEventListener('scroll', sync, { passive: true });
  sync();
})();
